import React, { useState, useEffect, useRef } from "react";
import {
  Users,
  ListChecks,
  Bell,
  Image as ImageIcon,
  UserPlus,
  ClipboardList,
  LogOut,
  ChevronDown,
  Search,
  Plus,
  FileSpreadsheet,
  Mail,
  Trash2,
  Pencil,
  Send,
  ChevronLeft,
  ChevronRight,
  Menu,
  X,
} from "lucide-react";
import '../Styles/dashboard.css';
import Swal from 'sweetalert2';
import * as XLSX from "xlsx";
import { useNavigate } from "react-router-dom";

import Attendees from "./Attendees";

import Dashgallery from "./Dashgallery";
import CommunityMember from "./communitymember";
import SubscriberList from "./subscriberlist";
import PartnerList from "./CollaborateList";
import DashboardFrontPage from "../pages/dashboardfrontpage";

// Change this if your backend runs on a different host/port
const API_BASE_URL = "https://vanakkamhrd.com";

// Readable names for the "How did you know" values saved by the form
const OPTION_LABELS = {
  "social-media": "Social Media",
  "hr-community": "HR Community",
  "whatsapp-group": "WhatsApp Group",
  "google-search": "Google Search",
  "website": "Website",
  "friend-colleague": "Friends / Colleagues",
  "referral": "Referral",
  "other": "Other",
};

const NAV = [
  {
    section: null,
    items: [
      {
        label: "Dashboard",
        icon: "/assets/dash_icon.png",
        isImage: true,
      },
    ],
  },
  {
    section: "Community",
    items: [
      { label: "Community Members List", icon: "/assets/commu.png", isImage: true },
      
      { label: "Subscribers", icon: "/assets/sub.png", isImage: true },
      // TODO: replace the icon with your own, for example "/assets/partner.png"
            { label: "Collaborate List", icon: "/assets/collab.png", isImage: true },
    ],
  },
  {
    section: "Gallery",
    items: [{ label: "Upload Event Photos", icon: "/assets/up.png", isImage: true }],
  },
  {
    section: "HR Events 2026",
    items: [
      {
        label: "Registration List",
        icon: "/assets/register.png",
        isImage: true,
        active: true,
        expandable: true,
      },
      { label: "Attendees List", icon: "/assets/attend.png", isImage: true, expandable: true },
    ],
  },
];

export default function RegisteredUsersDashboard() {

  const [mobileNavOpen, setMobileNavOpen] = useState(false); // mobile / tablet drawer
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activePage, setActivePage] = useState(
    () => localStorage.getItem("hrd_activePage") || "dashboard"
  );

  // false | "view" | "edit" - set by the Community Members page
  const [communityViewing, setCommunityViewing] = useState(false);

  const [registrationOpen, setRegistrationOpen] = useState(false);
  const [selectedRegistrationEvent, setSelectedRegistrationEvent] =
    useState("confluence");
  const [attendeesOpen, setAttendeesOpen] = useState(false);
  const [selectedAttendeesEvent, setSelectedAttendeesEvent] = useState("confluence");

  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();

  // Paid / Unpaid counts from the backend
  const [stats, setStats] = useState({ paid: 0, unpaid: 0 });

  // ---- Pagination state ----
  const [pageSize, setPageSize] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  // Track per-row "sending..." state for the Send Confirmation button
  const [sendingId, setSendingId] = useState(null);

  // ---- Bulk send state ----
  const [bulkSending, setBulkSending] = useState(false);

  // ---- Bulk delete state ----
  const [bulkDeleting, setBulkDeleting] = useState(false);

  // ---- Bulk special users (upload sheet) state ----
  const [bulkUploading, setBulkUploading] = useState(false);
  const bulkFileRef = useRef(null);
  const bulkPassRef = useRef("Delegate Pass"); // pass category of the sheet being uploaded

  // ---- Edit modal state ----
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [editPhoto, setEditPhoto] = useState(null); // new photo chosen in the Edit popup
  const [saving, setSaving] = useState(false);

  // ---- Add single user modal state ----
  const EMPTY_ADD_FORM = {
    fullName: "",
    designation: "",
    company: "",
    contact: "",
    personalEmail: "",
    officialEmail: "",
    howDidYouKnow: "",
    isPaid: "paid",
    image: null,
  };
  const [addOpen, setAddOpen] = useState(false);
  const [addForm, setAddForm] = useState(EMPTY_ADD_FORM);
  const [adding, setAdding] = useState(false);

  const fetchStats = async (event) => {
    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations/stats?event=${event}`);
      if (res.ok) setStats(await res.json());
    } catch (e) {
      console.error(e);
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const currentEvent = activePage === "festival" ? "festival" : "confluence";
      const res = await fetch(`${API_BASE_URL}/api/registrations?event=${currentEvent}`);
      if (!res.ok) throw new Error("Failed to load registered users");
      const data = await res.json();
      setUsers(data);
      setError(null);
      fetchStats(currentEvent);
    } catch (err) {
      console.error(err);
      setError("Could not load registrations. Is the backend running?");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activePage === "registration" || activePage === "festival") {
      setUsers([]);
      setSelected([]);
      setSelectAll(false);
      setQuery("");
      fetchUsers();
    }
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("hrd_activePage", activePage);
  }, [activePage]);

  useEffect(() => {
    localStorage.setItem("hrd_regOpen", registrationOpen);
  }, [registrationOpen]);

  useEffect(() => {
    localStorage.setItem("hrd_regEvent", selectedRegistrationEvent);
  }, [selectedRegistrationEvent]);

  useEffect(() => {
    localStorage.setItem("hrd_attOpen", attendeesOpen);
  }, [attendeesOpen]);

  useEffect(() => {
    localStorage.setItem("hrd_attEvent", selectedAttendeesEvent);
  }, [selectedAttendeesEvent]);

  // Search across name, designation, company, contact, both emails, options and order ID
  const filteredUsers = users.filter((u) => {
    const q = query.trim().toLowerCase();
    if (!q) return true;
    const orderText = u.orderNo || (u.orderId ? String(u.orderId).replace(/^order_/, "") : "");
    const optionText = OPTION_LABELS[u.options] || u.options || "";
    return [
      u.fullName,
      u.designation,
      u.company,
      u.contact,
      u.personalEmail,
      u.officialEmail,
      optionText,
      u.options,
      orderText,
    ].some((v) => String(v ?? "").toLowerCase().includes(q));
  });

  // Reset to page 1 whenever the search query or page size changes,
  // so the user doesn't land on an empty/out-of-range page.
  useEffect(() => {
    setCurrentPage(1);
  }, [query, pageSize]);

  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / pageSize));

  // Clamp currentPage if the dataset shrinks (e.g. after a delete)
  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  // Builds a compact page-number list with ellipses for large page counts
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }

    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    if (start > 2) pages.push("dots-start");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("dots-end");

    pages.push(totalPages);
    return pages;
  };

  const toggleAll = () => {
    setSelectAll((v) => !v);
    setSelected(selectAll ? [] : filteredUsers.map((u) => u.id));
  };

  const toggleOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSendConfirmation = async (id) => {
    setSendingId(id);
    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations/${id}/resend-email`, {
        method: "POST",
      });
      if (!res.ok) throw new Error("Failed to resend email");
      await fetchUsers();

      Swal.fire({
        icon: 'success',
        title: 'Confirmation Sent!',
        text: 'The confirmation email has been sent successfully.',
        confirmButtonColor: '#2f6fed',
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Send',
        text: 'Could not send the confirmation email. Please try again.',
        confirmButtonColor: '#e0432c',
      });
    } finally {
      setSendingId(null);
    }
  };

  const handleBulkSendEmail = async () => {
    if (selected.length === 0) {
      Swal.fire({
        icon: "info",
        title: "No Selection",
        text: "Please select at least one registration using the checkboxes.",
        confirmButtonColor: "#2f6fed",
      });
      return;
    }

    const result = await Swal.fire({
      icon: "question",
      title: "Send Bulk Email?",
      text: `Send confirmation email to ${selected.length} selected registration(s)?`,
      showCancelButton: true,
      confirmButtonText: "Yes, send it",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3D44B1",
      cancelButtonColor: "#6b7086",
    });

    if (!result.isConfirmed) return;

    setBulkSending(true);

    try {
      const res = await fetch(
        `${API_BASE_URL}/api/registrations/bulk-send-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ids: selected,
          }),
        }
      );

      const data = await res.json();

      console.log("Bulk email response:", data);

      if (!res.ok) {
        throw new Error(
          data.error || "Failed to start bulk emails"
        );
      }

      // Clear selected users
      setSelected([]);
      setSelectAll(false);

      // Refresh registration list
      await fetchUsers();

      // Show successful message
      Swal.fire({
        icon: "success",
        title: "Bulk Email Started!",
        text: data.message,
        confirmButtonColor: "#2f6fed",
      });

    } catch (err) {
      console.error("Bulk email error:", err);

      Swal.fire({
        icon: "error",
        title: "Failed to Send",
        text: err.message || "Could not start bulk emails. Please try again.",
        confirmButtonColor: "#e0432c",
      });

    } finally {
      setBulkSending(false);
    }
  };

  const handleBulkDelete = async () => {
    if (selected.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Selection',
        text: 'Please select at least one registration using the checkboxes.',
        confirmButtonColor: '#2f6fed',
      });
      return;
    }

    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: `Do you want to delete ${selected.length} selected registration(s)? This cannot be undone.`,
      showCancelButton: true,
      confirmButtonText: 'Yes, delete them',
      cancelButtonText: 'No, keep them',
      confirmButtonColor: '#e0432c',
      cancelButtonColor: '#6b7086',
    });

    if (!result.isConfirmed) return;

    setBulkDeleting(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations/bulk-delete`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids: selected }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to delete selected registrations");

      setUsers((prev) => prev.filter((u) => !selected.includes(u.id)));
      setSelected([]);
      setSelectAll(false);
      fetchStats(activePage === "festival" ? "festival" : "confluence");

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: `${data.deletedCount} registration(s) have been deleted.`,
        confirmButtonColor: '#2f6fed',
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Delete',
        text: 'Could not delete the selected registrations. Please try again.',
        confirmButtonColor: '#e0432c',
      });
    } finally {
      setBulkDeleting(false);
    }
  };

  const handleExportToExcel = () => {
    if (filteredUsers.length === 0) {
      Swal.fire({
        icon: 'info',
        title: 'No Data',
        text: 'There are no registrations to export.',
        confirmButtonColor: '#2f6fed',
      });
      return;
    }

    const exportData = filteredUsers.map((u, index) => ({
      "S.No": index + 1,
      "Full Name": u.fullName || "",
      "Designation": u.designation || "",
      "Company": u.company || "",
      "Contact": u.contact || "",
      "Personal Email": u.personalEmail || "",
      "Official Email": u.officialEmail || "",
      "Email Sent": u.confirmationSent ? "Sent" : "Unsent",
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registrations");

    worksheet["!cols"] = [
      { wch: 6 },
      { wch: 22 },
      { wch: 20 },
      { wch: 22 },
      { wch: 15 },
      { wch: 28 },
      { wch: 28 },
      { wch: 12 },
    ];

    const dateStr = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(workbook, `Registered_Users_${dateStr}.xlsx`);
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      icon: 'warning',
      title: 'Are you sure?',
      text: 'Do you want to delete this registration? This cannot be undone.',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'No, keep it',
      confirmButtonColor: '#e0432c',
      cancelButtonColor: '#6b7086',
    });

    if (!result.isConfirmed) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/registrations/${id}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error("Failed to delete");
      setUsers((prev) => prev.filter((u) => u.id !== id));
      fetchStats(activePage === "festival" ? "festival" : "confluence");

      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'The registration has been deleted.',
        confirmButtonColor: '#2f6fed',
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Failed to Delete',
        text: 'Could not delete the registration. Please try again.',
        confirmButtonColor: '#e0432c',
      });
    }
  };

  // Options / Order ID / Payment Status columns + Paid/Unpaid pills: TN HR Summit only
  const showPayCols = activePage === "festival";

  // ---- Edit modal handlers ----
  const openEditModal = (user) => {
    setEditingUser(user);
    setEditForm({
      fullName: user.fullName || "",
      designation: user.designation || "",
      company: user.company || "",
      contact: user.contact || "",
      personalEmail: user.personalEmail || "",
      officialEmail: user.officialEmail || "",
      options: user.options || "",
      isPaid: user.isPaid ? "paid" : "unpaid",
      orderNo: user.orderNo || (user.orderId ? String(user.orderId).replace(/^order_/, "") : ""),
      passCategory: user.passCategory || "Delegate Pass",
    });
  };

  const closeEditModal = () => {
    setEditingUser(null);
    setEditForm({});
    setEditPhoto(null);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      // multipart so a new photo can be sent with the details
      const fd = new FormData();
      fd.append("fullName", editForm.fullName);
      fd.append("designation", editForm.designation);
      fd.append("company", editForm.company);
      fd.append("contactNumber", editForm.contact);
      fd.append("personalEmail", editForm.personalEmail);
      fd.append("officialEmail", editForm.officialEmail);
      if (showPayCols) {
        fd.append("isPaid", editForm.isPaid === "paid" ? "true" : "false");
        fd.append("options", editForm.options || "");
        fd.append("howDidYouKnow", editForm.options || "");
        fd.append("orderNo", editForm.orderNo || "");
        fd.append("passCategory", editForm.passCategory || "Delegate Pass");
      }
      if (editPhoto) fd.append("image", editPhoto);

      const res = await fetch(`${API_BASE_URL}/api/registrations/${editingUser.id}`, {
        method: "PUT",
        body: fd,
      });
      if (!res.ok) throw new Error("Failed to update registration");
      await fetchUsers();
      closeEditModal();
    } catch (err) {
      console.error(err);
      alert("Failed to save changes. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  // ---- Add single user handlers ----
  const openAddModal = () => {
    setAddForm(EMPTY_ADD_FORM);
    setAddOpen(true);
  };

  const closeAddModal = () => {
    setAddOpen(false);
    setAddForm(EMPTY_ADD_FORM);
  };

  const handleAddChange = (e) => {
    const { name, value, files } = e.target;
    setAddForm((prev) => ({
      ...prev,
      [name]: name === "image" ? (files && files[0]) || null : value,
    }));
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setAdding(true);
    try {
      const fd = new FormData();
      fd.append("fullName", addForm.fullName);
      fd.append("designation", addForm.designation);
      fd.append("company", addForm.company);
      fd.append("contactNumber", addForm.contact);
      fd.append("personalEmail", addForm.personalEmail);
      fd.append("officialEmail", addForm.officialEmail);
      fd.append("eventName", activePage === "festival" ? "festival" : "confluence");
      if (showPayCols) {
        fd.append("howDidYouKnow", addForm.howDidYouKnow);
        fd.append("isPaid", addForm.isPaid === "paid" ? "true" : "false");
      }
      if (addForm.image) fd.append("image", addForm.image);

      const res = await fetch(`${API_BASE_URL}/api/registrations/add-single`, {
        method: "POST",
        body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || "Failed to add user");

      await fetchUsers();
      closeAddModal();

      Swal.fire({
        icon: "success",
        title: "User Added!",
        text: "The user has been added successfully.",
        confirmButtonColor: "#2f6fed",
      });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Failed to Add",
        text: err.message || "Could not add the user. Please try again.",
        confirmButtonColor: "#e0432c",
      });
    } finally {
      setAdding(false);
    }
  };

  // ---------------------------------------------------------------
  // BULK SPECIAL USERS: upload a sheet (.xlsx / .xls / .csv), every row
  // becomes a registration. Download the Google Sheet first:
  // File > Download > Microsoft Excel (.xlsx) or CSV.
  // Columns (any order): Full Name, Designation, Company, Contact,
  // Personal Email, Official Email  (optional: Options, Payment Status)
  // ---------------------------------------------------------------
  const normKey = (s) => String(s).toLowerCase().replace(/[^a-z0-9]/g, "");
  const BULK_KEYS = {
    fullName: ["fullname", "name", "username"],
    designation: ["designation", "currentdesignation", "jobtitle"],
    company: ["company", "companyname", "organization", "organizationname"],
    contact: ["contact", "contactnumber", "phone", "phonenumber", "mobile", "mobilenumber"],
    personalEmail: ["personalemail", "personalemailid", "email", "emailid"],
    officialEmail: ["officialemail", "officialemailid", "workemail"],
    options: ["options", "howdidyouknow"],
    payment: ["paymentstatus", "ispaid", "payment"],
    photo: ["photo", "photolink", "photourl", "image", "imagelink", "picture", "drivelink", "googledrivelink", "photodrivelink", "profilephoto"],
  };

  const pickCell = (row, field) => {
    for (const k of Object.keys(row)) {
      if (BULK_KEYS[field].includes(normKey(k))) return String(row[k] ?? "").trim();
    }
    return "";
  };

  const mapBulkRow = (row) => {
    const optionText = pickCell(row, "options");
    const optionKey =
      Object.entries(OPTION_LABELS).find(
        ([key, label]) => normKey(label) === normKey(optionText) || key === optionText
      )?.[0] || "";
    const pay = normKey(pickCell(row, "payment"));
    return {
      fullName: pickCell(row, "fullName"),
      designation: pickCell(row, "designation"),
      company: pickCell(row, "company"),
      contact: pickCell(row, "contact").replace(/\.0$/, ""),
      personalEmail: pickCell(row, "personalEmail").toLowerCase(),
      officialEmail: pickCell(row, "officialEmail").toLowerCase(),
      howDidYouKnow: optionKey,
      photoUrl: pickCell(row, "photo"),
      // special users are marked Paid unless the sheet says otherwise
      isPaid: !["unpaid", "no", "false", "0"].includes(pay),
    };
  };

  const uploadOneUser = async (r, eventName, sendEmail) => {
    const fd = new FormData();
    fd.append("fullName", r.fullName);
    fd.append("designation", r.designation);
    fd.append("company", r.company);
    fd.append("contactNumber", r.contact);
    fd.append("personalEmail", r.personalEmail);
    fd.append("officialEmail", r.officialEmail);
    fd.append("eventName", eventName);
    fd.append("noInvoice", "true"); // bulk users: ticket ID only, no invoice number
    fd.append("passCategory", bulkPassRef.current); // Delegate Pass (special) or Sponsor Pass (sponsor)
    if (r.photoUrl) fd.append("photoUrl", r.photoUrl); // Google Drive link
    if (sendEmail) fd.append("sendEmail", "true"); // registration email to both emails
    if (eventName === "festival") {
      fd.append("howDidYouKnow", r.howDidYouKnow);
      fd.append("isPaid", r.isPaid ? "true" : "false");
    }
    const res = await fetch(`${API_BASE_URL}/api/registrations/add-single`, {
      method: "POST",
      body: fd,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.error || "Failed to add");
    return data;
  };

  const handleBulkSpecialClick = () => {
    bulkPassRef.current = "Delegate Pass";
    if (bulkFileRef.current) bulkFileRef.current.click();
  };
  const handleBulkSponsorClick = () => {
    bulkPassRef.current = "Sponsor Pass";
    if (bulkFileRef.current) bulkFileRef.current.click();
  };

  const handleBulkFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = ""; // allows choosing the same file again
    if (!file) return;

    let rows = [];
    try {
      const wb = XLSX.read(await file.arrayBuffer(), { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const raw = XLSX.utils.sheet_to_json(ws, { defval: "", raw: false });
      rows = raw.map(mapBulkRow).filter((r) => r.fullName);
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Could not read the file",
        text: "Please upload the sheet as .xlsx or .csv.",
        confirmButtonColor: "#e0432c",
      });
      return;
    }

    if (rows.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No users found",
        text: "Make sure the first row has headers like Full Name, Designation, Company, Contact, Personal Email, Official Email.",
        confirmButtonColor: "#2f6fed",
      });
      return;
    }

    const eventName = activePage === "festival" ? "festival" : "confluence";
    const eventLabel = eventName === "festival" ? "TN HR Summit 2026" : "India HR Confluence 2026";

    const ok = await Swal.fire({
      icon: "question",
      title: `Add ${rows.length} ${bulkPassRef.current === "Sponsor Pass" ? "sponsor " : ""}users?`,
      text: `${rows.length} users from "${file.name}" will be added to ${eventLabel}.`,
      input: "checkbox",
      inputValue: 1,
      inputPlaceholder: "Also send the registration email (poster + delegate pass) to both email IDs",
      showCancelButton: true,
      confirmButtonText: "Yes, add them",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3D44B1",
      cancelButtonColor: "#6b7086",
    });
    if (!ok.isConfirmed) return;
    const sendEmail = Number(ok.value) === 1;

    setBulkUploading(true);
    Swal.fire({
      title: "Adding users...",
      html: `<b id="bulk-progress">0</b> / ${rows.length}`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    let done = 0;
    let added = 0;
    const failed = [];
    const photoIssues = [];
    let next = 0;

    // 3 uploads at a time
    const worker = async () => {
      while (next < rows.length) {
        const r = rows[next++];
        try {
          const data = await uploadOneUser(r, eventName, sendEmail);
          added++;
          if (data && data.photoError) photoIssues.push(`${r.fullName}: ${data.photoError}`);
        } catch (err) {
          failed.push(`${r.fullName}: ${err.message}`);
        }
        done++;
        const el = document.getElementById("bulk-progress");
        if (el) el.textContent = done;
      }
    };
    await Promise.all([worker(), worker(), worker()]);

    await fetchUsers();
    setBulkUploading(false);

    Swal.fire({
      icon: failed.length ? (added ? "warning" : "error") : "success",
      title: failed.length ? "Finished with some errors" : "All users added!",
      html:
        `<p><b>${added}</b> added${failed.length ? `, <b>${failed.length}</b> failed` : ""}.</p>` +
        (sendEmail && added
          ? `<p style="font-size:13px;color:#444">Registration emails are being sent in the background (about 15 per minute). Refresh the list later to see the Email Status turn to Sent.</p>`
          : "") +
        (photoIssues.length
          ? `<p style="color:#b45309;font-size:13px"><b>${photoIssues.length}</b> added without a photo:</p><div style="text-align:left;max-height:120px;overflow:auto;font-size:13px">${photoIssues
              .slice(0, 10)
              .map((f) => `<div>• ${f.replace(/</g, "&lt;")}</div>`)
              .join("")}${photoIssues.length > 10 ? `<div>...and ${photoIssues.length - 10} more</div>` : ""}</div>`
          : "") +
        (failed.length
          ? `<div style="text-align:left;max-height:180px;overflow:auto;font-size:13px">${failed
              .slice(0, 15)
              .map((f) => `<div>• ${f.replace(/</g, "&lt;")}</div>`)
              .join("")}${failed.length > 15 ? `<div>...and ${failed.length - 15} more</div>` : ""}</div>`
          : ""),
      confirmButtonColor: "#2f6fed",
    });
  };

  const total = users.length;
  const emailsSentCount = users.filter((u) => u.confirmationSent).length;

  // Mobile drawer: lock page scroll while it is open, and close it
  // automatically if the screen grows to desktop width.
  useEffect(() => {
    document.body.style.overflow = mobileNavOpen ? "hidden" : "";
    const onResize = () => {
      if (window.innerWidth > 1023) setMobileNavOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("resize", onResize);
    };
  }, [mobileNavOpen]);

  return (
    <div className="hrd-app">
      {/* Dark overlay behind the drawer (mobile / tablet only) */}
      {mobileNavOpen && (
        <div className="hrd-overlay" onClick={() => setMobileNavOpen(false)}></div>
      )}

      {/* ---------------- Sidebar ---------------- */}
      <aside className={`hrd-sidebar ${mobileNavOpen ? "open" : ""}`}>
        <div className="hrd-brand">
          <img src="/assets/vana.png" alt="Vanakkam HRD" className="hrd-logo" />
          <button
            type="button"
            className="hrd-drawer-close"
            aria-label="Close menu"
            onClick={() => setMobileNavOpen(false)}
          >
            <X size={20} />
          </button>
        </div>

        <nav className="hrd-nav">
          {NAV.map((group, gi) => (
            <div className="hrd-nav-group" key={gi}>
              {group.section && <div className="hrd-nav-label">{group.section}</div>}
              {group.items.map((item) => (
                <React.Fragment key={item.label}>

                  <button
                    className={`hrd-nav-item ${
                      activePage === "dashboard" && item.label === "Dashboard"
                        ? "active"
                        : (activePage === "registration" || activePage === "festival") && item.label === "Registration List"
                        ? "active"
                        : (activePage === "attendees" || activePage === "attendees-festival") &&
                          item.label === "Attendees List"
                        ? "active"
                        
                        : activePage === "gallery" && item.label === "Upload Event Photos"
                        ? "active"
                        : activePage === "community" && item.label === "Community Members List"
                        ? "active"
                        : activePage === "subscribers" && item.label === "Subscribers"
                        ? "active"
                                                : activePage === "partner" && item.label === "Collaborate List"
                        ? "active"
                        : ""
                    }`}
                    onClick={() => {
  if (item.label === "Dashboard") {
    setActivePage("dashboard");
    setMobileNavOpen(false);
  } else if (item.label === "Registration List") {
    setRegistrationOpen((prev) => !prev);
  } else if (item.label === "Attendees List") {
    setAttendeesOpen((prev) => !prev);
  } else if (item.label === "Collaborate List") {
    setActivePage("partner");
    setMobileNavOpen(false);
  } else if (item.label === "Upload Event Photos") {
    setActivePage("gallery");
    setMobileNavOpen(false);
  } else if (item.label === "Community Members List") {
    setActivePage("community");
    setMobileNavOpen(false);
  } else if (item.label === "Subscribers") {
    setActivePage("subscribers");
    setMobileNavOpen(false);
  }
}}
                  >
                    {item.isImage ? (
                      <img src={item.icon} alt={item.label} className="hrd-nav-icon-img" />
                    ) : (
                      <item.icon size={16} strokeWidth={2} />
                    )}

                    <span>{item.label}</span>

                    {item.expandable && (
                      <ChevronDown
                        size={14}
                        className={`hrd-nav-chevron ${
                          (item.label === "Registration List" && registrationOpen) ||
                          (item.label === "Attendees List" && attendeesOpen)
                            ? "open"
                            : ""
                        }`}
                      />
                    )}
                  </button>

                  {/* Registration Dropdown */}
                  {item.label === "Registration List" && (
                    <div className={`hrd-registration-submenu ${registrationOpen ? "open" : ""}`}>
                      <button
                        className={`hrd-registration-subitem ${
                          selectedRegistrationEvent === "confluence" && activePage === "registration"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => {
                          setSelectedRegistrationEvent("confluence");
                          setActivePage("registration");
                          setMobileNavOpen(false);
                        }}
                      >
                        <span className="hrd-submenu-dot">•</span>
                        <span>HR Confluence 2026</span>
                      </button>

                      <button
                        className={`hrd-registration-subitem ${
                          selectedRegistrationEvent === "festival" && activePage === "festival"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => {
                          setSelectedRegistrationEvent("festival");
                          setActivePage("festival");
                          setMobileNavOpen(false);
                        }}
                      >
                        <span className="hrd-submenu-dot">•</span>
                        <span>TN HR Summit 2026</span>
                      </button>
                    </div>
                  )}

                  {/* Attendees Dropdown */}
                  {item.label === "Attendees List" && (
                    <div className={`hrd-registration-submenu ${attendeesOpen ? "open" : ""}`}>
                      <button
                        className={`hrd-registration-subitem ${
                          selectedAttendeesEvent === "confluence" && activePage === "attendees"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => {
                          setSelectedAttendeesEvent("confluence");
                          setActivePage("attendees");
                          setMobileNavOpen(false);
                        }}
                      >
                        <span className="hrd-submenu-dot">•</span>
                        <span>HR Confluence 2026</span>
                      </button>

                      <button
                        className={`hrd-registration-subitem ${
                          selectedAttendeesEvent === "festival" && activePage === "attendees-festival"
                            ? "active"
                            : ""
                        }`}
                        onClick={() => {
                          setSelectedAttendeesEvent("festival");
                          setActivePage("attendees-festival");
                          setMobileNavOpen(false);
                        }}
                      >
                        <span className="hrd-submenu-dot">•</span>
                        <span>TN HR Summit 2026</span>
                      </button>
                    </div>
                  )}

                </React.Fragment>
              ))}
            </div>
          ))}
        </nav>

      </aside>

      {/* ---------------- Mobile / tablet top bar (menu button) ---------------- */}
      <div className="hrd-mobile-bar">
        <button
          type="button"
          className="hrd-burger"
          aria-label="Open menu"
          aria-expanded={mobileNavOpen}
          onClick={() => setMobileNavOpen(true)}
        >
          <Menu size={22} />
        </button>
        <img src="/assets/vana.png" alt="Vanakkam HRD" className="hrd-mobile-logo" />
      </div>

      {/* ---------------- Main content ---------------- */}
      <main className="dash-hrd-main">
        <header className="hrd-topbar hrd-panel">
          <h1>
            {activePage === "registration" || activePage === "festival" ? (
              <>
                Registered Users –
                <span className="hrd-topbar-sub">
                  {activePage === "festival" ? "TN HR Summit 2026" : "India HR Confluence 2026"}
                </span>
              </>
            ) : activePage === "dashboard" ? (
              "Dashboard"
            ) : activePage === "attendees" || activePage === "attendees-festival" ? (
              "Check-In for Attendees - India HR Confluence 2026"
            
            ) : activePage === "gallery" ? (
              "Gallery Management"
            ) : activePage === "community" ? (
              communityViewing === "edit"
                ? "Edit Community Members List"
                : communityViewing
                ? "View Community Members List"
                : "Community Members"
            ) : activePage === "subscribers" ? (
              "Subscribers"
                        ) : activePage === "partner" ? (
              "Collaborate List"
            ) : (
              ""
            )}
          </h1>

          <button
            type="button"
            className="hrd-logout"
            onClick={() => {
              console.log("logout button clicked");
              localStorage.clear();
              navigate("/admin/login", { replace: true });
            }}
          >
            <LogOut size={14} />
            Logout
          </button>
        </header>

        {activePage === "dashboard" ? (
          <DashboardFrontPage onNavigate={setActivePage} />
        ) : activePage === "registration" || activePage === "festival" ? (
          <section className="hrd-panel">
            <div className="hrd-stats">
              <span className="hrd-pill hrd-pill--total">Total Registered : {total}</span>
              {showPayCols && (
                <>
                  <span className="hrd-pill hrd-pill--paid">Paid : {stats.paid}</span>
                  <span className="hrd-pill hrd-pill--unpaid">Unpaid : {stats.unpaid}</span>
                </>
              )}
              <span className="hrd-pill hrd-pill--sent">Emails Sent : {emailsSentCount}</span>
              <span className="hrd-pill hrd-pill--unsent">
                Emails Unsent : {total - emailsSentCount}
              </span>
              <button className="hrd-pill hrd-pill--export" onClick={handleExportToExcel}>
                <span className="excel-icon-wrap">
                  <img src="/assets/excel.png" alt="Excel" className="excel-icon excel-icon--default" />
                  <img src="/assets/excel-white.png" alt="Excel" className="excel-icon excel-icon--hover" />
                </span>
                Export To Excel
              </button>
            </div>

            <div className="hrd-actions">
              <button
                className="hrd-btn hrd-btn--sponsor"
                onClick={handleBulkSponsorClick}
                disabled={bulkUploading}
              >
                <img src="/assets/plu.png" alt="Plus" className="plus-icon" />
                {bulkUploading ? "Uploading..." : "Add Bulk Sponsor Users"}
              </button>
              <button
                className="hrd-btn hrd-btn--special"
                onClick={handleBulkSpecialClick}
                disabled={bulkUploading}
              >
                <img src="/assets/pluss.png" alt="Plus" className="plus-icon" />
                {bulkUploading ? "Uploading..." : "Add Bulk Special Users"}
              </button>
              <input
                ref={bulkFileRef}
                type="file"
                accept=".xlsx,.xls,.csv"
                style={{ display: "none" }}
                onChange={handleBulkFile}
              />
              <button
                className="hrd-pill hrd-pill--bulk"
                onClick={handleBulkSendEmail}
                disabled={bulkSending}
              >
                <Mail size={14} />
                {bulkSending ? "Sending..." : "Sent Bulk Email"}
              </button>
              <button className="hrd-pill hrd-pill--bulk" onClick={openAddModal}>
                <UserPlus size={14} />
                Add Single User
              </button>
              <button
                className="hrd-btn hrd-btn--delete"
                onClick={handleBulkDelete}
                disabled={bulkDeleting}
              >
                <img src="/assets/bulk_delete.png" alt="Bulk Delete" className="delete-icon" />
                {bulkDeleting ? "Deleting..." : "Bulk Delete"}
              </button>
            </div>

            {/* Table controls */}
            <div className="hrd-table-controls">
              <label className="hrd-show-entries">
                Show Entries:
                <select
                  value={pageSize}
                  onChange={(e) => setPageSize(Number(e.target.value))}
                >
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
              </label>
              <div className="hrd-search">
                <Search size={14} />
                <input
                  placeholder="Search..."
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                />
              </div>
            </div>

            {/* Table */}
            <div className="hrd-table-wrap">
              {loading ? (
                <p style={{ padding: "20px" }}>Loading registered users...</p>
              ) : error ? (
                <p style={{ padding: "20px", color: "#e0432c" }}>{error}</p>
              ) : (
                <table className="hrd-table">
                  <thead>
                    <tr>
                      <th className="hrd-checkbox-col">
                        <label className="hrd-select-all">
                          <input type="checkbox" checked={selectAll} onChange={toggleAll} />
                          <span>Select All</span>
                        </label>
                      </th>
                      <th>S.No</th>
                      <th>Full Name</th>
                      <th>Designation</th>
                      <th>Company</th>
                      <th>Contact</th>
                      <th>Personal Email</th>
                      <th>Official Email</th>
                      {showPayCols && (
                        <>
                          <th>Options</th>
                          <th>Order ID</th>
                          <th>Payment Status</th>
                          <th>Pass Category</th>
                        </>
                      )}
                      <th>Email Status</th>
                      <th>Send Confirmation</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedUsers.length === 0 ? (
                      <tr>
                        <td colSpan={showPayCols ? 15 : 11} style={{ padding: "20px", textAlign: "center" }}>
                          No registrations yet.
                        </td>
                      </tr>
                    ) : (
                      paginatedUsers.map((u, index) => (
                        <tr key={u.id}>
                          <td className="hrd-checkbox-col">
                            <input
                              type="checkbox"
                              checked={selected.includes(u.id)}
                              onChange={() => toggleOne(u.id)}
                            />
                          </td>
                          <td>{(currentPage - 1) * pageSize + index + 1}</td>
                          <td>
                            <div className="hrd-user-cell">
                              {u.imagePath ? (
                                <img
                                  src={`${API_BASE_URL}${u.imagePath}`}
                                  alt={u.fullName}
                                  className="hrd-avatar hrd-avatar--photo"
                                />
                              ) : (
                                <span className="hrd-avatar">{u.fullName?.charAt(0)}</span>
                              )}
                              {u.fullName}
                            </div>
                          </td>
                          <td>{u.designation}</td>
                          <td>{u.company}</td>
                          <td>{u.contact}</td>
                          <td>{u.personalEmail}</td>
                          <td>{u.officialEmail}</td>
                          {showPayCols && (
                            <>
                              <td>{OPTION_LABELS[u.options] || u.options || "-"}</td>
                              <td>{u.orderNo || (u.orderId ? String(u.orderId).replace(/^order_/, "") : "-")}</td>
                              <td>
                                <span
                                  className={
                                    u.isPaid
                                      ? "hrd-paytext hrd-paytext--paid"
                                      : "hrd-paytext hrd-paytext--unpaid"
                                  }
                                >
                                  {u.isPaid ? "Paid" : "Unpaid"}
                                </span>
                              </td>
                              <td>{u.passCategory || "Delegate Pass"}</td>
                            </>
                          )}
                          <td>
                            {u.confirmationSent ? (
                              <span className="hrd-status-pill hrd-status-pill--sent">
                                ✓ Sent
                              </span>
                            ) : (
                              <span className="hrd-status-pill hrd-status-pill--unsent">
                                ✕ UnSent
                              </span>
                            )}
                          </td>
                          <td>
                            <button
                              className={`hrd-send-confirm-btn ${
                                u.confirmationSent ? "confirmed" : "send"
                              }`}
                              disabled={sendingId === u.id || u.confirmationSent}
                              onClick={() => handleSendConfirmation(u.id)}
                            >
                              <Send size={13} />
                              {sendingId === u.id
                                ? "Sending..."
                                : u.confirmationSent
                                ? "Sent Confirmation"
                                : "Send Confirmation"}
                            </button>
                          </td>
                          <td>
                            <div className="hrd-row-actions">
                              <button
                                className="hrd-icon-btn hrd-icon-btn--edit"
                                title="Edit"
                                onClick={() => openEditModal(u)}
                              >
                                <Pencil size={13} />
                                Edit
                              </button>
                              <button
                                className="hrd-icon-btn hrd-icon-btn--delete"
                                title="Delete"
                                onClick={() => handleDelete(u.id)}
                              >
                                <Trash2 size={13} />
                                Delete
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>

            {/* Footer / pagination */}
            <div className="hrd-table-footer">
              <span>
                Showing {paginatedUsers.length === 0 ? 0 : (currentPage - 1) * pageSize + 1}
                &ndash;
                {(currentPage - 1) * pageSize + paginatedUsers.length} of {filteredUsers.length} Members
              </span>
              <div className="hrd-pagination">
                <button
                  className="hrd-page-btn"
                  onClick={() => goToPage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <ChevronLeft size={14} />
                </button>

                {getPageNumbers().map((p, i) =>
                  p === "dots-start" || p === "dots-end" ? (
                    <span key={`${p}-${i}`} className="hrd-page-dots">
                      …
                    </span>
                  ) : (
                    <button
                      key={p}
                      className={`hrd-page-btn${p === currentPage ? " active" : ""}`}
                      onClick={() => goToPage(p)}
                    >
                      {p}
                    </button>
                  )
                )}

                <button
                  className="hrd-page-btn"
                  onClick={() => goToPage(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <ChevronRight size={14} />
                </button>
              </div>
            </div>
          </section>
        ) : activePage === "attendees" || activePage === "attendees-festival" ? (
          <Attendees selectedEvent={selectedAttendeesEvent} />
        
        ) : activePage === "gallery" ? (
          <Dashgallery />
        ) : activePage === "community" ? (
          <CommunityMember onViewChange={setCommunityViewing} />
        ) : activePage === "subscribers" ? (
          <SubscriberList />
        ) : activePage === "partner" ? (
          <PartnerList />
        ) : null}
      </main>

      {/* ---------------- Add Single User Modal ---------------- */}
      {addOpen && (
        <div className="hrd-modal-overlay" onClick={closeAddModal}>
          <div className="hrd-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="hrd-modal-title">Add Single User</h2>

            <form onSubmit={handleAddSubmit} className="hrd-modal-form">
              <div className="hrd-modal-field">
                <label>Full Name</label>
                <input name="fullName" value={addForm.fullName} onChange={handleAddChange} required />
              </div>

              <div className="hrd-modal-field">
                <label>Designation</label>
                <input name="designation" value={addForm.designation} onChange={handleAddChange} required />
              </div>

              <div className="hrd-modal-field">
                <label>Company</label>
                <input name="company" value={addForm.company} onChange={handleAddChange} required />
              </div>

              <div className="hrd-modal-field">
                <label>Contact Number</label>
                <input name="contact" value={addForm.contact} onChange={handleAddChange} required />
              </div>

              <div className="hrd-modal-field">
                <label>Personal Email</label>
                <input type="email" name="personalEmail" value={addForm.personalEmail} onChange={handleAddChange} required />
              </div>

              <div className="hrd-modal-field">
                <label>Official Email</label>
                <input type="email" name="officialEmail" value={addForm.officialEmail} onChange={handleAddChange} required />
              </div>

              {showPayCols && (
                <>
                  <div className="hrd-modal-field">
                    <label>Options (How did you know)</label>
                    <select name="howDidYouKnow" value={addForm.howDidYouKnow} onChange={handleAddChange}>
                      <option value="">-- Select --</option>
                      {Object.entries(OPTION_LABELS).map(([val, label]) => (
                        <option key={val} value={val}>{label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="hrd-modal-field">
                    <label>Payment Status</label>
                    <select name="isPaid" value={addForm.isPaid} onChange={handleAddChange}>
                      <option value="paid">Paid</option>
                      <option value="unpaid">Unpaid</option>
                    </select>
                  </div>
                </>
              )}

              <div className="hrd-modal-field">
                <label>Photo (JPG, optional)</label>
                <input type="file" name="image" accept=".jpg,.jpeg" onChange={handleAddChange} />
              </div>

              <div className="hrd-modal-actions">
                <button type="button" className="hrd-modal-btn hrd-modal-btn--cancel" onClick={closeAddModal}>
                  Cancel
                </button>
                <button type="submit" className="hrd-modal-btn hrd-modal-btn--save" disabled={adding}>
                  {adding ? "Adding..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ---------------- Edit Modal ---------------- */}
      {editingUser && (
        <div className="hrd-modal-overlay" onClick={closeEditModal}>
          <div className="hrd-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="hrd-modal-title">Edit Registration</h2>

            <form onSubmit={handleEditSubmit} className="hrd-modal-form">
              <div className="hrd-modal-field">
                <label>Full Name</label>
                <input
                  name="fullName"
                  value={editForm.fullName}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Designation</label>
                <input
                  name="designation"
                  value={editForm.designation}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Company</label>
                <input
                  name="company"
                  value={editForm.company}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Contact Number</label>
                <input
                  name="contact"
                  value={editForm.contact}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Personal Email</label>
                <input
                  type="email"
                  name="personalEmail"
                  value={editForm.personalEmail}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>Official Email</label>
                <input
                  type="email"
                  name="officialEmail"
                  value={editForm.officialEmail}
                  onChange={handleEditChange}
                  required
                />
              </div>

              <div className="hrd-modal-field">
                <label>
                  Photo (JPG){editingUser.imagePath ? " - leave empty to keep the current photo" : ""}
                </label>
                <input
                  type="file"
                  accept=".jpg,.jpeg"
                  onChange={(e) => setEditPhoto((e.target.files && e.target.files[0]) || null)}
                />
              </div>

              {showPayCols && (
                <>
                  <div className="hrd-modal-field">
                    <label>Options (How did you know)</label>
                    <select
                      name="options"
                      value={editForm.options}
                      onChange={handleEditChange}
                    >
                      <option value="">-- Select --</option>
                      {/* keeps an older saved value visible even if it is not in the list */}
                      {editForm.options && !OPTION_LABELS[editForm.options] && (
                        <option value={editForm.options}>{editForm.options}</option>
                      )}
                      {Object.entries(OPTION_LABELS).map(([val, label]) => (
                        <option key={val} value={val}>{label}</option>
                      ))}
                    </select>
                  </div>

                  <div className="hrd-modal-field">
                    <label>Order ID</label>
                    <input
                      name="orderNo"
                      value={editForm.orderNo}
                      onChange={handleEditChange}
                    />
                  </div>

                  <div className="hrd-modal-field">
                    <label>Pass Category</label>
                    <select
                      name="passCategory"
                      value={editForm.passCategory}
                      onChange={handleEditChange}
                    >
                      <option value="Delegate Pass">Delegate Pass</option>
                      <option value="Sponsor Pass">Sponsor Pass</option>
                    </select>
                  </div>

                  <div className="hrd-modal-field">
                    <label>Payment Status</label>
                    <select
                      name="isPaid"
                      value={editForm.isPaid}
                      onChange={handleEditChange}
                    >
                      <option value="paid">Paid</option>
                      <option value="unpaid">Unpaid</option>
                    </select>
                  </div>
                </>
              )}

              <div className="hrd-modal-actions">
                <button
                  type="button"
                  className="hrd-modal-btn hrd-modal-btn--cancel"
                  onClick={closeEditModal}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="hrd-modal-btn hrd-modal-btn--save"
                  disabled={saving}
                >
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}